export type DispatchErrorPayload = {
  error?: unknown;
  defaultErrorMessage?: string;
};

export class DispatchError extends Error {
  error?: unknown;

  defaultErrorMessage?: string;

  constructor({ error, defaultErrorMessage }: DispatchErrorPayload) {
    super(defaultErrorMessage);
    this.name = 'DispatchError';
    this.error = error;
    this.defaultErrorMessage = defaultErrorMessage;
  }
}

export const rejectWithError = (payload: DispatchErrorPayload): Promise<never> =>
  Promise.reject(new DispatchError(payload));
